import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Loan } from 'src/model/loan.model';
import { LoanGroup } from 'src/model/loanGroup.model';
import { LoanGroupService } from 'src/services/loan-group.service';
import { LoanService } from 'src/services/loan.service';

@Component({
    selector: 'app-update-commission-message',
    templateUrl: './update-commission-message.component.html',
    styleUrl: './update-commission-message.component.scss',
    standalone: false
})
export class UpdateCommissionMessageComponent {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private loanService = inject(LoanService);
  private lgService = inject(LoanGroupService);

  @Input() compareString = "";
  value: string;

  @Input() lgId: number;
  @Input() loanId: number;
  message: string;
  @Input() loan: Loan;
  loanGroup: LoanGroup;
  requestPercentage: number;
  maxCommissionRate: number;
  @Input() currentCommissionRate: number;
  reason: string;

  checkError() {
    let error = "";

    if (this.currentCommissionRate != undefined) {
      if (this.requestPercentage == undefined)
        error += "- Request Percentage empty\n";
      if (this.reason == undefined)
        error += "- Reason empty\n"
      if (this.currentCommissionRate == this.requestPercentage) {
        error += "- Requested rate is same with current rate, no need update\n"
      }
    }

    error = (error != "") ? "Please fix error below before submitting: \n" + error : error;
    return error;
  }

  generateCommissionRequestMessage() {
    this.value = undefined;
    const error = this.checkError();
    if (error == "") {
      if (this.loan != undefined) {
        this.maxCommissionRate = this.sharedService.getMaxCommissionRate(this.loan) * 100;

        if (Number(this.requestPercentage) > this.maxCommissionRate) {
          this.sharedService.openAlert("Request rate more than maximum commission rate of " + this.maxCommissionRate + "%", ALERT_TYPE.DANGER);
        } else {
          this.value =
            "#" + this.lgId + "-" + this.loan.ID + "\n" +
            "Customer Name: " + this.loan.CustomerName + "\n" +
            "Customer IC: " + this.sharedService.processICNum(this.loan.ICNumber) + "\n" +
            "Principal: RM " + this.loan.Principal + "\n" +
            "Current Commission Rate: " + this.currentCommissionRate + "%\n";

          if (this.compareString == "" || this.compareString == undefined) {
            this.value += "---------------------------------------\n" +
              "Requested Commission Rate: " + this.requestPercentage + "%\n" +
              "Request Reason:" + this.reason
          }
        }
      }
    }
    else
      this.sharedService.openAlert(error, ALERT_TYPE.DANGER);
  }
  async findLoanAndCompare() {
    const regexp = /#(\d+)-(\d+)/;
    const ids = this.message.match(regexp);

    if (ids) {
      this.lgId = Number(ids[1]);
      this.loanId = Number(ids[2]);
      this.loan = await this.loanService.getLoanById(Number(ids[2]));

      this.loanGroup = await this.lgService.getSingleLoanGroup(this.lgId);
      this.currentCommissionRate = this.loanGroup.CommissionRateLimit;

      //fill in rate and reason
      const rateMatch = this.message.match(/Requested Commission Rate:(.*)%/);
      const reasonMatch = this.message.match(/Request Reason:(.*)/);

      const rate = rateMatch ? rateMatch[1].trim() : '';
      const reason = reasonMatch ? reasonMatch[1].trim() : '';

      this.requestPercentage = Number(rate);
      this.reason = reason;

      this.compareString = this.message.split("---------------------------------------")[0];
      this.generateCommissionRequestMessage();
    }
    else
      this.sharedService.openAlert("Please paste the correct commission request message", ALERT_TYPE.DANGER);
  }

  reset() {
    this.activeModal.close();
  }
}
